import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { InventorySource } from 'src/app/acumatica/EntityServices/OrderPicking.service';
import { ConfirmationDialog } from 'src/app/common/confirmation-dialog/confirmation-dialog.component';

class SelectableInventorySource extends InventorySource {
  selected: boolean = false;
}

@Component({
  selector: 'app-restock-held-inventory',
  templateUrl: './restock-held-inventory.component.html',
  styleUrls: ['./restock-held-inventory.component.css']
})
export class RestockHeldInventoryComponent {

  heldItems: SelectableInventorySource[];
  warehouseLocations: string[];
  restockedItems: SelectableInventorySource[] = [];

  constructor(
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<RestockHeldInventoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      locations: string[]
      items: InventorySource[]
    }
  ) {
    this.heldItems = data.items.map(item => item as SelectableInventorySource);
    this.warehouseLocations = data.locations;
  }

  close() { this.dialogRef.close(this.restockedItems); }

  selectAllRemaining() {
    this.heldItems.forEach(item => item.selected = true);
    this.itemFormReset();
  }

  // #region User Entry Form

  itemForm = new FormGroup({
    inventoryID: new FormControl(),
    lotSerialNbr: new FormControl()
  });
  get inventoryID() { return this.itemForm.get('inventoryID')! }
  get lotSerialNbr() { return this.itemForm.get('lotSerialNbr')! }

  onItemEntered(item: string | number | null) {
    if (item == null) return;
    // check if the entered value is a Location ID
    item = item.toString().trim();
    if (this.warehouseLocations.contains(item)) this.restockSelectionToLocation(item);
  }

  onLotNumberEntered(lotNbr: string | number | null) {
    this.toggleItemSelection(this.itemForm.get('inventoryID')!.value, this.itemForm.get('lotSerialNbr')!.value);
  }

  itemFormReset() {
    this.inventoryID.setValue(null);
    this.lotSerialNbr.setValue(null);
    setTimeout(() => (<any>this.inventoryID).focus(), 100);
  }

  // #endregion

  // #region Inventory Restock / Transfer handling

  /** handler for the user providing an item to be 'selected' */
  toggleItemSelection(inventoryID: string, lotSerialNbr: string) {
    // find the item in the held items list
    let item = this.heldItems.find(item => item.InventoryID == inventoryID && item.LotSerialNbr == lotSerialNbr);

    if (item !== undefined) { // item scanned is in the held items list
      // toggle selection flag
      item.selected = !item.selected;
      // move it to the top of the list
      this.heldItems.remove(item);
      this.heldItems = [item].concat(this.heldItems);
      // prepare for next item
      this.itemFormReset();
    }
  }

  /** assign the given Location ID to the items that are 'selected' */
  async restockSelectionToLocation(locationID: string) {
    let selectedItems: SelectableInventorySource[] = this.heldItems.length == 1 ? this.heldItems : this.heldItems.filter(item => item.selected);

    (new Promise<void>((resolve, reject) => {
      // items have been explicitly selected, proceed to doing the location transfer
      if (selectedItems.length >= 0) resolve();
      else {
        // confirm with user if transferring all remaining items to this locaiton
        this.dialog.open(ConfirmationDialog, {
          data: {
            icon: 'question',
            message: "No items have been selected.\nTransfer all remaining items to \"" + locationID + "\"",
            buttons: [
              { text: 'Yes', color: 'primary', value: true },
              { text: 'No, cancel', color: 'accent', value: false }
            ]
          }
        }).afterClosed().subscribe(transferAllRemaining => {
          if (transferAllRemaining) {
            selectedItems = this.heldItems;
            resolve();
          }
          else reject();
        });
      }
    })).then(() => {

      selectedItems.forEach(item => {
        // update location on selected items
        item.LocationID = locationID;
        // remove them from the list of items still needing restocked
        this.heldItems.remove(item);
        // add them to the list of items that have been restocked
        this.restockedItems.push(item);
      });

      if (this.heldItems.length == 0) this.close();
      else this.itemFormReset();

    });
  }
  // #endregion
}
